import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/solid/document-fill.svg'


const _hoisted_1 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_2 = { class: "border-r-2 mx-1" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_4 = { class: "grid grid-cols-3 mt-6" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "grid grid-cols-2 text-right m-auto border-r-2 mt-0" }
const _hoisted_11 = { class: "mx-1 pr-5" }
const _hoisted_12 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_13 = { class: "grid grid-cols-2 gap-4 mt-4" }
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 0,
  class: "flex bg-gray-100 border-2 border-gray-200 w-full h-24 m-auto text-brand-500 rounded-md"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "flex bg-gray-100 border-2 border-gray-200 w-full h-24 m-auto text-brand-500 rounded-md"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  class: "linked-icon w-12 m-auto",
  src: _imports_0,
  alt: "document icon"
}, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "text-gray-900 font-medium mt-2" }
const _hoisted_21 = { class: "text-sm" }

import { // store
		localesStore
	} from '@/store/locales'

	import { // vue
		computed
	} from 'vue'
	
	
	const __default__ = { name: 'TransportationDetails' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		attendee: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()
	
	const transportationType = computed(() => {
		return props.attendee?.fieldData?.emergency_transport ? store.getLabel('684') : props.attendee?.fieldData?.['attendees__TRANSPORTATION__transportationID::type_display']
	})

	const transportationCost = computed(() => {
		return props.attendee?.fieldData?.cost_transportation || 
			props.attendee?.fieldData?.cost_emergency
	})

	const time = computed(() => {
		if(props.attendee?.fieldData?.['attendees__TRANSPORTATION__transportationID::type_display'] === 'Multiple') {
			return props.attendee?.fieldData?.['attendees__TRANSPORTATION__transportationID::time_multiple']
		}
		else {
			return props.attendee?.fieldData?.time || props.attendee?.fieldData?.time_emergency
		}
	})

return (_ctx: any,_cache: any) => {
  const _component_data_display = _resolveComponent("data-display")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: _unref(store).getLabel('185'),
            value: transportationType.value
          }, null, 8, ["loading", "label", "value"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: _unref(store).getLabel('45'),
            value: _ctx.$filters.jpy(transportationCost.value)
          }, null, 8, ["loading", "label", "value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: _unref(store).getLabel('332'),
            value: _ctx.$filters.timeDuration(time.value)
          }, null, 8, ["loading", "label", "value"])
        ]),
        (!transportationType.value?.includes('Emergency'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_data_display, {
                loading: __props.loading,
                label: _unref(store).getLabel('32'),
                value: __props.attendee?.fieldData?.date_last_checked
              }, null, 8, ["loading", "label", "value"])
            ]))
          : _createCommentVNode("", true),
        (!transportationType.value?.includes('Emergency'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !__props.attendee?.fieldData?.primary}])
              }, [
                (__props.attendee?.fieldData?.primary)
                  ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                      key: 0,
                      class: "h-5 w-5"
                    }))
                  : (_openBlock(), _createBlock(_component_MinusIconMini, {
                      key: 1,
                      class: "h-5 w-5"
                    })),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(store).getLabel('292')), 1)
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      (__props.attendee?.portalData?.attendees__TRANSPORTATION__multipleID?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_tw_table, {
              data: __props.attendee?.portalData?.attendees__TRANSPORTATION__multipleID
            }, {
              default: _withCtx(() => [
                _createVNode(_component_tw_table_column, {
                  header: _unref(store).getLabel('1')
                }, {
                  default: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString(row["attendees__TRANSPORTATION__multipleID::type_display"]), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_tw_table_column, {
                  header: _unref(store).getLabel('229')
                }, {
                  default: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString(_ctx.$filters.jpy(row["attendees__TRANSPORTATION__multipleID::cost"])), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_tw_table_column, {
                  header: _unref(store).getLabel('332')
                }, {
                  default: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString(_ctx.$filters.timeDuration(row["attendees__TRANSPORTATION__multipleID::time"])), 1)
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["data"])
          ]))
        : _createCommentVNode("", true),
      (transportationType.value?.includes('Emergency') && __props.attendee?.portalData?.attendees__TRANSPORTATION__attendeesID?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_tw_table, {
              data: __props.attendee?.portalData?.attendees__TRANSPORTATION__attendeesID
            }, {
              default: _withCtx(() => [
                _createVNode(_component_tw_table_column, {
                  header: _unref(store).getLabel('1')
                }, {
                  default: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString(row["attendees__TRANSPORTATION__attendeesID::type_display"]), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_tw_table_column, {
                  header: _unref(store).getLabel('229')
                }, {
                  default: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString(_ctx.$filters.jpy(row["attendees__TRANSPORTATION__attendeesID::cost"])), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_tw_table_column, {
                  header: _unref(store).getLabel('332')
                }, {
                  default: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString(_ctx.$filters.timeDuration(row["attendees__TRANSPORTATION__attendeesID::time"])), 1)
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["data"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('43'),
        value: _ctx.$filters.jpy(__props.attendee?.fieldData?.cost),
        "value-class": "text-right pr-18",
        "label-class": "-ml-4"
      }, null, 8, ["loading", "label", "value"]),
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('716') + ' (1)',
        value: _ctx.$filters.jpy(__props.attendee?.fieldData?.other1_withholding),
        "value-class": "text-right pr-18",
        "label-class": "-ml-4"
      }, null, 8, ["loading", "label", "value"]),
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('718'),
        value: _ctx.$filters.jpy(__props.attendee?.fieldData?.total_before_tax),
        "value-class": "text-right pr-18",
        "label-class": "-ml-4"
      }, null, 8, ["loading", "label", "value"]),
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('372'),
        value: _ctx.$filters.jpy(__props.attendee?.fieldData?.consumption_withholding),
        "value-class": "text-right pr-18",
        "label-class": "-ml-4"
      }, null, 8, ["loading", "label", "value"]),
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('717'),
        value: _ctx.$filters.jpy(__props.attendee?.fieldData?.total_before_taxes_witholding),
        "value-class": "text-right pr-18",
        "label-class": "-ml-4"
      }, null, 8, ["loading", "label", "value"]),
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('715'),
        value: _ctx.$filters.jpy(__props.attendee?.fieldData?.withholding_amount),
        "value-class": "text-right pr-18",
        "label-class": "-ml-4"
      }, null, 8, ["loading", "label", "value"]),
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('373'),
        value: _ctx.$filters.jpy(__props.attendee?.fieldData?.subtotal_withholding),
        "value-class": "text-right pr-18",
        "label-class": "-ml-4"
      }, null, 8, ["loading", "label", "value"]),
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('716') + ' (2)',
        value: _ctx.$filters.jpy(__props.attendee?.fieldData?.other2_withholding),
        "value-class": "text-right pr-18",
        "label-class": "-ml-4"
      }, null, 8, ["loading", "label", "value"]),
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('374'),
        value: _ctx.$filters.jpy(__props.attendee?.fieldData?.grand_total_withholding),
        "value-class": "text-right pr-18",
        "label-class": "-ml-4"
      }, null, 8, ["loading", "label", "value"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", null, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: _unref(store).getLabel('726') + ' (1)',
            value: __props.attendee?.fieldData?.memo_display_other1
          }, null, 8, ["loading", "label", "value"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: _unref(store).getLabel('726') + ' (2)',
            value: __props.attendee?.fieldData?.memo_display_other2
          }, null, 8, ["loading", "label", "value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.attendee?.portalData?.['attendees__DOCUMENTS__attendeesTaxesID'], (document) => {
          return (_openBlock(), _createElementBlock("div", {
            key: document.recordId
          }, [
            _createElementVNode("a", {
              target: "_blank",
              class: "w-full truncate hover:opacity-70",
              href: document?.signedUrl,
              download: ""
            }, [
              (document.ext == 'jpeg' || document.ext == 'jpg' || document.ext == 'png' || document.ext == 'gif')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("img", {
                      src: document.signedUrl,
                      class: "w-full h-full object-cover rounded-md"
                    }, null, 8, _hoisted_16)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19)),
              _createElementVNode("div", _hoisted_20, _toDisplayString(document?.['attendees__DOCUMENTS__attendeesTaxesID::name_display']), 1),
              _createElementVNode("div", _hoisted_21, _toDisplayString(document?.['attendees__DOCUMENTS__attendeesTaxesID::description_display']), 1)
            ], 8, _hoisted_14)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})